import ServiceLayout from "@/components/ServiceLayout";
import { QuoteModal } from "@/components/QuoteModal";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function Ingolstadt() {
  return (
    <ServiceLayout
      title="Umzugsunternehmen in Ingolstadt"
      description="Zuverlässige und schnelle Umzüge in Ingolstadt. Profitieren Sie von unserer langjährigen Erfahrung und unserem umfassenden Service."
      image="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df9351010807725c6b00.jpg"
      heroBg="https://vibe.filesafe.space/1781514922662573702/assets/8b00d754-acfd-4be3-a8d0-a548c5ac491b.png"
      content={
        <>
          <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight">
            Stressfrei umziehen in Ingolstadt
          </h2>
          <p className="text-lg text-neutral-600">
            Sie planen Ihren Wohnortwechsel nach oder innerhalb von Ingolstadt? Wir sind Ihr zuverlässiger Partner für einen reibungslosen Umzug. Wir kümmern uns um alles – vom sicheren Einpacken über den Transport bis hin zum Aufbau am Zielort.
          </p>
          <p className="text-lg text-neutral-600">
            Verlassen Sie sich auf unsere Expertise und unser geschultes Personal. Wir machen Ihren Umzug in Ingolstadt zu einer positiven und stressfreien Erfahrung.
          </p>
          <ul className="space-y-3 mt-6">
            {[
              "Kostenlose Vor-Ort-Beratung",
              "Erfahrenes und freundliches Team",
              "Sicherer Transport mit modernen Fahrzeugen",
              "Flexible Terminvereinbarung"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3 text-neutral-800 font-medium">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                {item}
              </li>
            ))}
          </ul>
        </>
      }
      extendedContent={
        <div className="bg-white">
          <section className="py-16 bg-neutral-50">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Ihr verlässliches Umzugsunternehmen in Ingolstadt</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Wohnungswechsel ist oft ein großer Schritt, der viel Planung und Kraft erfordert. Damit Sie sich auf das Wesentliche konzentrieren können, stehen wir Ihnen als professionelles Umzugsunternehmen in Ingolstadt zur Seite. Wir übernehmen die schwere Arbeit, organisieren den Transport und sorgen dafür, dass Ihr Hab und Gut sicher und unbeschadet am neuen Wohnort ankommt.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ob Sie innerhalb von Ingolstadt umziehen, aus einer anderen Region in die Donaustadt kommen oder Ingolstadt verlassen – wir sind Ihr kompetenter Partner. Mit unserer Erfahrung, einem bestens geschulten Team und modernen Transportfahrzeugen garantieren wir Ihnen einen stressfreien und termingerechten Umzug.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Kostenloses Angebot anfordern
                      </Button>
                    </QuoteModal>
                    <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
                      <a href="tel:+4915888640762">
                        <Phone className="w-5 h-5 mr-2" />
                        +49 15888 640762
                      </a>
                    </Button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 pt-8">
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Privatumzüge in Ingolstadt</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Jeder Haushalt ist anders. Deshalb bieten wir Ihnen maßgeschneiderte Lösungen für Ihren Privatumzug in Ingolstadt. Vom einfachen Möbeltransport bis zum komfortablen Full-Service-Umzug inklusive Ein- und Auspackservice passen wir unsere Leistungen Ihren Bedürfnissen an.
                    </p>
                  </div>
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Firmenumzüge & Büroumzüge</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Bei einem gewerblichen Umzug ist Zeit Geld. Wir planen Ihren Firmenumzug in Ingolstadt effizient und zielgerichtet, um Ausfallzeiten zu minimieren. IT-Ausstattung, Akten und Büromöbel werden von uns sicher transportiert und fachgerecht wieder aufgebaut.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Umfassende Handwerksleistungen für Ihren Umzug</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Umzug ist erst abgeschlossen, wenn alles am richtigen Platz steht und funktioniert. Deshalb bieten wir Ihnen in Ingolstadt weitreichende Handwerksleistungen an. Unsere erfahrenen Monteure übernehmen die Demontage und Montage Ihrer Möbel, bauen Ihre Küche ab und am neuen Standort wieder auf.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Zusätzlich kümmern wir uns um alle anfallenden Elektro- und Lichtinstallationen. Wir schließen Herde an, montieren Deckenlampen und installieren Waschmaschinen sicher und fachgerecht. Auch Bodenbelagsarbeiten und kleinere Renovierungen gehören zu unserem Service, damit Sie sich in Ihrem neuen Zuhause sofort wohlfühlen können.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Jetzt beraten lassen
                      </Button>
                    </QuoteModal>
                  </div>
                </div>

                <div className="bg-primary/5 p-8 border-l-4 border-primary mt-8">
                  <h3 className="font-heading text-2xl font-bold mb-3">Sicherheit und Festpreisgarantie</h3>
                  <p className="text-neutral-700 leading-relaxed">
                    Wir legen großen Wert auf Transparenz. Nach einer kostenlosen Besichtigung Ihres Umzugsguts in Ingolstadt erhalten Sie von uns ein verbindliches Festpreisangebot. Keine versteckten Gebühren, keine bösen Überraschungen. Zudem ist Ihr Eigentum während des gesamten Umzugs durch unsere Transport- und Betriebshaftpflichtversicherung optimal geschützt.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-neutral-950 text-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="font-heading text-3xl font-bold mb-6">Gründe für Easy Umzug in Ingolstadt</h2>
                <div className="grid sm:grid-cols-3 gap-8 mt-12 text-left">
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Erfahrenes Team</h3>
                    <p className="text-neutral-400">Unsere Mitarbeiter sind geschult im Umgang mit empfindlichen Möbeln und schweren Gegenständen.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Kostenlose Besichtigung</h3>
                    <p className="text-neutral-400">Wir beraten Sie vor Ort und erstellen ein maßgeschneidertes, unverbindliches Angebot.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Komplettservice</h3>
                    <p className="text-neutral-400">Mit unseren Handwerksleistungen bieten wir Ihnen einen Rundum-Sorglos-Service für Ihren Umzug.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      }
    />
  );
}
